/**
 * @fileoverview POST handler for the "/apps/connected_content_credential/create" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { appsConnectedContentCredentialCreateCacheKeys } from "./constants";
import type {
  PostAppsConnectedContentCredentialCreateProps,
  AppsConnectedContentCredentialCreateResult,
  AppsConnectedContentCredentialCreateResultErrors,
} from "./types";

export const postAppsConnectedContentCredentialCreate = reactQueryMutationAdapter(
  appsConnectedContentCredentialCreateCacheKeys,
  createMutationFetcherFunctionWithShadowError<AppsConnectedContentCredentialCreateResultErrors>()(
    (props: PostAppsConnectedContentCredentialCreateProps): Promise<AppsConnectedContentCredentialCreateResult> => {
      return fetch(
        "/apps/connected_content_credential/create",
        "POST",
        props,
        {},
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
